// src/config/queryClient.js
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Podstawowa konfiguracja dla wszystkich zapytań
      retry: 1,                // liczba ponownych prób w przypadku błędu
      staleTime: 1000 * 60,    // dane są "świeże" przez 1 minutę
      cacheTime: 1000 * 60 * 5, // dane są przechowywane w cache przez 5 minut
      refetchOnWindowFocus: false, // odświeżaj dane gdy użytkownik wraca do karty
    }
  }
});